// extracted by css-extract-rspack-plugin
export default {"block":"block-gNSF_t","headerWrapper":"headerWrapper-m832hE","header":"header-_39RsI","requirements":"requirements-UOvAvc"};